export default __webpack_public_path__ + "static/media/download.514c6901.svg";